import { render, staticRenderFns } from "./LabelCustom.vue?vue&type=template&id=d1d03b86&"
import script from "./LabelCustom.vue?vue&type=script&lang=js&"
export * from "./LabelCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports